import React, {useEffect, useState} from 'react';
import { Box } from '@mui/material';
import { useParams, useNavigate } from 'react-router-dom';
import ChanceStepperContainer from '../../containers/chancemng/setpper/ChanceStepperContainer';



const ChanceStepPage = () => {
  const { id, step, tab } = useParams();
  const [activeStep, setActiveStep] = useState(0);
  const [activeTap, setActiveTap] = useState(0);
  let navigate = useNavigate();

  useEffect(() => {
   if(step){
     setActiveStep(step-1);
   //  console.log(step,'step');
   }
   if(tab){
    setActiveTap(tab-1);
   // console.log(tab,'tab');
   }

   
  }, [id, step, tab]);

  const handleTabChange = (event, newValue)=>{
    // console.log('handleTabChange', newValue);
    // setActiveTap(newValue);
    let newStep = newValue+1;
    navigate(`/chancemng/${id}/${step}/${newStep}`);
  }

  return (
    
    <Box
      sx={{
        mt: 2,
        mx: 2,
      }}
    >
     
      <ChanceStepperContainer activeStep={activeStep} activeTap={activeTap} handleTabChange={handleTabChange}/>
     
    </Box>
  );
};

export default ChanceStepPage;
